import React from 'react';

export default function SkeletonLoader({ count = 4, height = 96, className = '' }) {
  return (
    <div className={`grid gap-3 ${className}`}>
      <style>{`
        @keyframes production-skeleton-sweep {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
      {Array.from({ length: count }).map((_, idx) => (
        <div
          key={idx}
          className="rounded-xl border border-slate-200"
          style={{
            height,
            backgroundColor: '#e2e8f0',
            backgroundImage: 'linear-gradient(90deg, #e2e8f0 0%, #f8fafc 35%, #cbd5e1 50%, #f8fafc 65%, #e2e8f0 100%)',
            backgroundSize: '220% 100%',
            animation: `production-skeleton-sweep ${1.45 + (idx % 3) * 0.12}s linear infinite`,
            willChange: 'background-position',
          }}
        />
      ))}
    </div>
  );
}
